<template>
  <div class="tab">
    <div class="tab-selector">
      <a
        href="javascript:void(0);"
        @click="checkout('Automotive')"
        :class="{ active: this.acviteTab == 'Automotive' }"
        >{{ tabList[0] }}</a
      >
      <a
        href="javascript:void(0);"
        @click="checkout('New Energy')"
        :class="{ active: this.acviteTab == 'New Energy' }"
        >{{ tabList[1] }}</a
      >
      <a
        href="javascript:void(0);"
        @click="checkout('Consumer Electronics')"
        :class="{ active: this.acviteTab == 'Consumer Electronics' }"
        >{{ tabList[2] }}</a
      >
      <a
        href="javascript:void(0);"
        @click="checkout('Industrial')"
        :class="{ active: this.acviteTab == 'Industrial' }"
        >{{ tabList[3] }}</a
      >
    </div>
    <div class="contentbox">
      <!-- 轮播图组件 -->
      <div class="swiper-box">
        <swiperNormalVue
          swiperID="1"
          :imgList="swiperList"
          :key="acviteTab"
        ></swiperNormalVue>
      </div>
      <div class="text-des">
        <div class="bar">{{ tabName }}</div>
        <div class="des">
          {{ des }}
        </div>
        <div class="button-box">
          <button1 :path="linkUrl" :text="buttonText"></button1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swiperNormalVue from "@/components/swiper-normal/index.vue";
import button1 from "@/components/cmrbutton/type2.vue";
import { getItem } from "@/utils/localStorage";
export default {
  name: "tab",
  components: {
    swiperNormalVue,
    button1,
  },
  data() {
    return {
      tabName: "",
      tabList: [],
      acviteTab: "Automotive",
      des: "",
      swiperList: [],
      swiperNum: 0,
      buttonText: "",
      linkUrl: {},
    };
  },
  methods: {
    checkout(str) {
      this.acviteTab = str;
      //切换数据
      if (str == "Automotive") {
        if (getItem("language") == "zh-cn") {
          this.swiperList = [
            {
              id: 5,
              imgUrl: require("@/assets/images/home/home-swiper-Automotive.jpg"),
              title: "汽车",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Automotive-power",
                  avtiveTab: "Automotive",
                },
              },
            },
            {
              id: 0,
              imgUrl: require("@/assets/images/home/home-swiper-Automotive-Sensor.jpg"),
              title: "传感器",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Automotive-Sensor",
                  avtiveTab: "Automotive",
                },
              },
            },
            {
              id: 1,
              imgUrl: require("@/assets/images/home/home-swiper-Automotive-filter.jpg"),
              title: "滤波器",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Automotive-Filter",
                  avtiveTab: "Automotive",
                },
              },
            },
            {
              id: 2,
              imgUrl: require("@/assets/images/home/home-swiper-Automotive-Lidar.jpg"),
              title: "激光雷达系统",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Automotive-LiDAR",
                  avtiveTab: "Automotive",
                },
              },
            },
            {
              id: 3,
              imgUrl: require("@/assets/images/home/home-swiper-Automotive-Power Steering System.png"),
              title: "动力转向系统",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Automotive-power",
                  avtiveTab: "Automotive",
                },
              },
            },
            {
              id: 4,
              imgUrl: require("@/assets/images/home/home-swiper-auto4.png"),
              title: "转向装置",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Automotive-power",
                  avtiveTab: "Automotive",
                },
              },
            },
          ];
          this.tabName = "汽车";
          this.des =
            "斯莫尔的磁性技术被广泛应用于汽车行业，以提高各种部件的性能和效率。我们使用可编程磁化技术开发先进的磁传感器，用于发动机控制系统、制动系统和传动系统。纳米晶体材料用于生产电动汽车和混合动力汽车的高频变压器和电感器，提高了功率转换效率，减少了能量损失。";
        } else {
          this.swiperList = [
            {
              id: 5,
              imgUrl: require("@/assets/images/home/home-swiper-Automotive.jpg"),
              title: "Automotive",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Automotive-power",
                  avtiveTab: "Automotive",
                },
              },
            },
            {
              id: 0,
              imgUrl: require("@/assets/images/home/home-swiper-Automotive-Sensor.jpg"),
              title: "Sensor Applications",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Automotive-Sensor",
                  avtiveTab: "Automotive",
                },
              },
            },
            {
              id: 1,
              imgUrl: require("@/assets/images/home/home-swiper-Automotive-filter.jpg"),
              title: "Filter",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Automotive-Filter",
                  avtiveTab: "Automotive",
                },
              },
            },
            {
              id: 2,
              imgUrl: require("@/assets/images/home/home-swiper-Automotive-Lidar.jpg"),
              title: "LiDAR Systems",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Automotive-LiDAR",
                  avtiveTab: "Automotive",
                },
              },
            },
            {
              id: 3,
              imgUrl: require("@/assets/images/home/home-swiper-Automotive-Power Steering System.png"),
              title: "Power Steering System",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Automotive-power",
                  avtiveTab: "Automotive",
                },
              },
            },
            {
              id: 4,
              imgUrl: require("@/assets/images/home/home-swiper-auto4.png"),
              title: "Steering",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Automotive-power",
                  avtiveTab: "Automotive",
                },
              },
            },
          ];
          this.tabName = "Automotive";
          this.des =
            "CMR's magnetic technologies are widely used in the automotive industry to improve the performance and efficiency of various components. We use programmable magnetization technology is applied to develop advanced magnetic sensors, which are used in engine control systems, brake systems, and transmission systems.";
        }
        this.linkUrl = {
          name: "applications",
          params: {
            activeTab: "Automotive",
            md: "Automotive",
          },
        };
      } else if (str == "New Energy") {
        if (getItem("language") == "zh-cn") {
          this.swiperList = [
            {
              id: 0,
              imgUrl: require("@/assets/images/home/home-swiper-new energy.jpg"),
              title: "绿色能源",
              path: {
                path: "/applications",
                query: {
                  md: "Eco-friendly resource",
                  avtiveTab: "New Energy",
                },
              },
            },
            {
              id: 1,
              imgUrl: require("@/assets/images/home/home-swiper-wind.jpg"),
              title: "风能",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-New-Wind",
                  avtiveTab: "New Energy",
                },
              },
            },
          ];
          this.tabName = "新能源";
          this.des =
            "斯莫尔的磁性技术在新能源行业发挥着至关重要的作用，包括风能、太阳能和储能。我们的纳米晶体材料广泛用于能量转换器的高频滤波器组件，提供有效的EMI抑制和减少能量损失。";
        } else {
          this.swiperList = [
            {
              id: 0,
              imgUrl: require("@/assets/images/home/home-swiper-new energy.jpg"),
              title: "Eco-friendly Resource",
              path: {
                path: "/applications",
                query: {
                  md: "Eco-friendly resource",
                  avtiveTab: "New Energy",
                },
              },
            },
            {
              id: 1,
              imgUrl: require("@/assets/images/home/home-swiper-wind.jpg"),
              title: "Wind Power",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-New-Wind",
                  avtiveTab: "New Energy",
                },
              },
            },
          ];
          this.tabName = "New Energy";
          this.des =
            "CMR's magnetic technologies play a vital role in the new energy industry, including wind power, solar power, and energy storage. Our nanocrystalline materials are widely used in high-frequency filter components for energy converters, providing effective EMI suppression and reducing energy loss.";
        }
        this.linkUrl = {
          name: "applications",
          params: {
            activeTab: "New Energy",
            md: "Eco-friendly resourc",
          },
        };
      } else if (str == "Consumer Electronics") {
        if (getItem("language") == "zh-cn") {
          this.swiperList = [
            {
              id: 0,
              imgUrl: require("@/assets/images/home/home-swiper-Consumer Electronics.jpg"),
              title: "消费电子产品",
              path: {
                path: "/applications",
                query: {
                  md: "Convenient Life",
                  avtiveTab: "Consumer Electronics",
                },
              },
            },
            {
              id: 1,
              imgUrl: require("@/assets/images/home/home-swiper-Consumer Electronics-Accessories.jpg"),
              title: "配件",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Consumer-Accessories",
                  avtiveTab: "Consumer Electronics",
                },
              },
            },
            {
              id: 2,
              imgUrl: require("@/assets/images/home/home-swiper-Consumer Electronics-wireless charging.jpg"),
              title: "无线充电",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Consumer-Wireless",
                  avtiveTab: "Consumer Electronics",
                },
              },
            },
          ];
          this.tabName = "消费电子";
          this.des =
            "斯莫尔的磁性技术被用于消费电子行业，以提高各种设备的性能和功能。我们的可编程磁化技术应用于先进磁传感器的开发，这些传感器用于智能手机、笔记本电脑和其他便携式设备。";
        } else {
          this.swiperList = [
            {
              id: 0,
              imgUrl: require("@/assets/images/home/home-swiper-Consumer Electronics.jpg"),
              title: "Consumer Electronics",
              path: {
                path: "/applications",
                query: {
                  md: "Convenient Life",
                  avtiveTab: "Consumer Electronics",
                },
              },
            },
            {
              id: 1,
              imgUrl: require("@/assets/images/home/home-swiper-Consumer Electronics-Accessories.jpg"),
              title: "Accessories",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Consumer-Accessories",
                  avtiveTab: "Consumer Electronics",
                },
              },
            },
            {
              id: 2,
              imgUrl: require("@/assets/images/home/home-swiper-Consumer Electronics-wireless charging.jpg"),
              title: "Wireless Charging",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Consumer-Wireless",
                  avtiveTab: "Consumer Electronics",
                },
              },
            },
          ];
          this.tabName = "Consumer Electronics";
          this.des =
            "CMR's magnetic technologies are used in the consumer electronics industry to boost the performance and functionality of various devices. Our programmable magnetization technology is applied in the development of advanced magnetic sensors, which are used in smartphones, laptops, and other portable devices.";
        }
        this.linkUrl = {
          name: "applications",
          params: {
            activeTab: "Consumer Electronics",
            md: "Convenient Life",
          },
        };
      } else {
        if (getItem("language") == "zh-cn") {
          this.swiperList = [
            // {
            //   id: 0,
            //   imgUrl: require("@/assets/images/home/home-swiper-Household electrical appliances.jpg"),
            //   title: "家用电器",
            //   path: {
            //     path: "/applications",
            //     query: {
            //       md: "Applications-Innovative-Household",
            //       avtiveTab: "Home Appliances",
            //     },
            //   },
            // },
            {
              id: 2,
              imgUrl: require("@/assets/images/home/home-swiper-Household Electronics.jpg"),
              title: "家用电器",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Innovative-Household",
                  avtiveTab: "Home Appliances",
                },
              },
            },
            {
              id: 1,
              imgUrl: require("@/assets/images/home/home-swiper-house2.jpg"),
              title: "其他应用工具",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Innovative-Other",
                  avtiveTab: "Home Appliances",
                },
              },
            },
            {
              id: 3,
              imgUrl: require("@/assets/images/home/home-swiper-Other Appliance.jpg"),
              title: "其他应用工具",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Innovative-Other",
                  avtiveTab: "Home Appliances",
                },
              },
            },
          ];
          this.tabName = "家电和其他工具";
          this.des =
            "在家用电器行业，斯莫尔的磁性技术被用于各种应用，如电机控制、电源和照明。我们的磁芯和模块提高了冰箱、空调和洗衣机等家用电器的效率、可靠性和安全性，从而提高了能源节约和产品性能。";
        } else {
          this.swiperList = [
            // {
            //   id: 0,
            //   imgUrl: require("@/assets/images/home/home-swiper-Household electrical appliances.jpg"),
            //   title: "Household Electronics",
            //   path: {
            //     path: "/applications",
            //     query: {
            //       md: "Applications-Innovative-Household",
            //       avtiveTab: "Home Appliances",
            //     },
            //   },
            // },
            {
              id: 2,
              imgUrl: require("@/assets/images/home/home-swiper-Household Electronics.jpg"),
              title: "Household Electronics",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Innovative-Household",
                  avtiveTab: "Home Appliances",
                },
              },
            },
            {
              id: 1,
              imgUrl: require("@/assets/images/home/home-swiper-house2.jpg"),
              title: "Other Appliance",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Innovative-Other",
                  avtiveTab: "Home Appliances",
                },
              },
            },
            {
              id: 3,
              imgUrl: require("@/assets/images/home/home-swiper-Other Appliance.jpg"),
              title: "Other Appliance",
              path: {
                path: "/applications",
                query: {
                  md: "Applications-Innovative-Other",
                  avtiveTab: "Home Appliances",
                },
              },
            },
          ];
          this.tabName = "Home Appliances";
          this.des =
            "In the home appliances industry,CMR's magnetic technologies are used in various applications such as motor control,power supply, and lighting.Our magnetic cores and modules offer improved efficiency,reliability,and safety in home appliances such as refrigerators,air conditioners,and washing machines,leading to improved energy savings and product performance.";
        }
        this.linkUrl = {
          name: "applications",
          params: {
            activeTab: "Home Appliances",
            md: "Innovative Home",
          },
        };
      }
    },
  },
  mounted() {
    if (getItem("language") == "zh-cn") {
      this.tabName = "汽车";
      this.des =
        "斯莫尔的磁性技术被广泛应用于汽车行业，以提高各种部件的性能和效率。我们使用可编程磁化技术开发先进的磁传感器，用于发动机控制系统、制动系统和传动系统。纳米晶体材料用于生产电动汽车和混合动力汽车的高频变压器和电感器，提高了功率转换效率，减少了能量损失。";
      this.tabList = ["汽车", "新能源", "消费电子", "家电和其他工具"];
      this.swiperList = [
        {
          id: 5,
          imgUrl: require("@/assets/images/home/home-swiper-Automotive.jpg"),
          title: "汽车",
          path: {
            path: "/applications",
            query: {
              md: "Applications-Automotive-power",
              avtiveTab: "Automotive",
            },
          },
        },
        {
          id: 0,
          imgUrl: require("@/assets/images/home/home-swiper-Automotive-Sensor.jpg"),
          title: "传感器",
          path: {
            path: "/applications",
            query: {
              md: "Applications-Automotive-Sensor",
              avtiveTab: "Automotive",
            },
          },
        },
        {
          id: 1,
          imgUrl: require("@/assets/images/home/home-swiper-Automotive-filter.jpg"),
          title: "滤波器",
          path: {
            path: "/applications",
            query: {
              md: "Applications-Automotive-Filter",
              avtiveTab: "Automotive",
            },
          },
        },
        {
          id: 2,
          imgUrl: require("@/assets/images/home/home-swiper-Automotive-Lidar.jpg"),
          title: "激光雷达系统",
          path: {
            path: "/applications",
            query: {
              md: "Applications-Automotive-LiDAR",
              avtiveTab: "Automotive",
            },
          },
        },
        {
          id: 3,
          imgUrl: require("@/assets/images/home/home-swiper-Automotive-Power Steering System.png"),
          title: "动力转向系统",
          path: {
            path: "/applications",
            query: {
              md: "Applications-Automotive-power",
              avtiveTab: "Automotive",
            },
          },
        },
        {
          id: 4,
          imgUrl: require("@/assets/images/home/home-swiper-auto4.png"),
          title: "转向装置",
          path: {
            path: "/applications",
            query: {
              md: "Applications-Automotive-power",
              avtiveTab: "Automotive",
            },
          },
        },
      ];
      this.buttonText = "了解更多";
      2;
    } else {
      this.tabName = "Automotive";
      this.tabList = [
        "Automotive",
        "New Energy",
        "Consumer Electronics",
        "Home Appliances",
      ];
      this.des =
        "CMR's magnetic technologies are widely used in the automotive industry to improve the performance and efficiency of various components. We use programmable magnetization technology is applied to develop advanced magnetic sensors, which are used in engine control systems, brake systems, and transmission systems.";
      this.swiperList = [
        {
          id: 5,
          imgUrl: require("@/assets/images/home/home-swiper-Automotive.jpg"),
          title: "Automotive",
          path: {
            path: "/applications",
            query: {
              md: "Applications-Automotive-power",
              avtiveTab: "Automotive",
            },
          },
        },
        {
          id: 0,
          imgUrl: require("@/assets/images/home/home-swiper-Automotive-Sensor.jpg"),
          title: "Sensor Applications",
          path: {
            path: "/applications",
            query: {
              md: "Applications-Automotive-Sensor",
              avtiveTab: "Automotive",
            },
          },
        },
        {
          id: 1,
          imgUrl: require("@/assets/images/home/home-swiper-Automotive-filter.jpg"),
          title: "Filter",
          path: {
            path: "/applications",
            query: {
              md: "Applications-Automotive-Filter",
              avtiveTab: "Automotive",
            },
          },
        },
        {
          id: 2,
          imgUrl: require("@/assets/images/home/home-swiper-Automotive-Lidar.jpg"),
          title: "LiDAR Systems",
          path: {
            path: "/applications",
            query: {
              md: "Applications-Automotive-LiDAR",
              avtiveTab: "Automotive",
            },
          },
        },
        {
          id: 3,
          imgUrl: require("@/assets/images/home/home-swiper-Automotive-Power Steering System.png"),
          title: "Power Steering System",
          path: {
            path: "/applications",
            query: {
              md: "Applications-Automotive-power",
              avtiveTab: "Automotive",
            },
          },
        },
        {
          id: 4,
          imgUrl: require("@/assets/images/home/home-swiper-auto4.png"),
          title: "Steering",
          path: {
            path: "/applications",
            query: {
              md: "Applications-Automotive-power",
              avtiveTab: "Automotive",
            },
          },
        },
      ];
      this.buttonText = "Learn More";
    }
    this.linkUrl = {
      name: "applications",
      params: {
        activeTab: "Automotive",
        md: "Automotive",
      },
    };
  },
};
</script>

<style lang="less" scoped>
.tab {
  margin-top: 0.8rem;
  .tab-selector {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 2.6rem;
    a {
      display: block;
      color: #000;
      font-weight: 700;
      font-size: 0.3rem;
      position: relative;
    }
    .active {
      color: #b94060;
      // &::after {
      //   position: absolute;
      //   display: block;
      //   content: "";
      //   width: 40%;
      //   height: 0.05rem;
      //   bottom: -0.25rem;
      //   border-bottom: 0.05rem solid #b94060;
      // }
    }
  }
  .contentbox {
    display: flex;
    // justify-content: space-between;
    margin-top: 0.2rem;
    .swiper-box {
      width: 8.5rem;
    }
    .text-des {
      margin-left: 1.5rem;
      width: 6.4371rem;
      .bar {
        display: inline-block;
        vertical-align: top;
        position: relative;
        font-size: 0.4rem;
        line-height: 0.6465rem;
        color: #000;
        font-weight: 700;
        margin-bottom: 0.6rem;
        &::after {
          position: absolute;
          display: block;
          content: "";
          width: 1.4rem;
          height: 0.05rem;
          left: 2%;
          border-bottom: 0.08rem solid #b94060;
        }
      }
      .button-box {
        margin-top: 0.6rem;
      }
    }
  }
}
@media screen and (max-width: 760px) {
  .tab {
    margin: 0 0;
    box-sizing: border-box;
    padding: 0 0.3rem;
    .tab-selector {
      padding: 0 0;
      margin-top: 0.9rem;
      flex-wrap: wrap;
      justify-content: space-between;
      a {
        font-size: 14px;
        width: 45%;
        margin-bottom: 0.6rem;
      }
    }
    .contentbox {
      flex-direction: column;
      margin-top: 0rem;
      .swiper-box {
        width: 100%;
        height: auto;
      }
      .text-des {
        margin-top: 0.9rem;
        margin-left: 0;
        width: 100%;
        .button-box {
          margin-top: 0.6rem;
        }
        .bar {
          padding-bottom: 0;
          margin-bottom: 0.8rem;
          font-size: 18px;
          &::after {
            border-bottom: 0.12rem solid #b94060;
            bottom: -0.3rem;
          }
        }
      }
    }
  }
}
</style>
